import { BulkBeneficiaryFileReducer, BulkBeneficiaryFileReducerStateWithListObject, BulkBeneficiaryFileReducerStateWithoutListObject, bulkBeneficiaryFileType } from "./types";

const OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE = {
    data: null,
    loading: false,
    error: null
};

const OBJECT_WITH_LIST_RESPONSE_INIT_STATE = {
    data: {
        metadata: {
            totalCount: 0,
            currentPageRecords: 0,
            totalPages: 0,
            links: {
                self: null,
                first: null,
                previous: null,
                next: null,
                last: null
            }
        },
        records: []
    },
    loading: false,
    error: null
};

const UploadBulkBeneficiaryFileReducer = (state: BulkBeneficiaryFileReducerStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE, action: BulkBeneficiaryFileReducer) => {
    switch (action.type) {
        case bulkBeneficiaryFileType.UPLOAD_BULK_BENEFICIARY_FILE: {
            return {
                loading: true,
            };
        }
        case bulkBeneficiaryFileType.UPLOAD_BULK_BENEFICIARY_FILE_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null
            };
        }
        case bulkBeneficiaryFileType.UPLOAD_BULK_BENEFICIARY_FILE_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error,
            };
        }
        case bulkBeneficiaryFileType.RESET_UPLOAD_BULK_BENEFICIARY_FILE: {
            return {
                data: {},
                loading: false,
                error: null
            };
        }

        default:
            return { ...state };
    }
};

const ListBulkBeneficiaryFileReducer = (state: BulkBeneficiaryFileReducerStateWithListObject = OBJECT_WITH_LIST_RESPONSE_INIT_STATE, action: BulkBeneficiaryFileReducer) => {
    switch (action.type) {
        case bulkBeneficiaryFileType.FETCH_BULK_BENEFICIARY_FILE: {
            return {
                ...state,
                loading: true
            };
        }
        case bulkBeneficiaryFileType.FETCH_BULK_BENEFICIARY_FILE_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data
            };
        }
        case bulkBeneficiaryFileType.FETCH_BULK_BENEFICIARY_FILE_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error
            };
        }

        case bulkBeneficiaryFileType.RESET_FETCH_BULK_BENEFICIARY_FILE:
            return {
                ...state,
                data: {
                    metadata: {
                        totalCount: 0,
                        currentPageRecords: 0,
                        totalPages: 0,
                        links: {
                            self: null,
                            first: null,
                            previous: null,
                            next: null,
                            last: null
                        }
                    },
                    records: []
                },
                loading: false,
                error: false
            };
        default:
            return { ...state };
    }
};


const DownloadBulkBeneficiaryFileReducer = (state: BulkBeneficiaryFileReducerStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE, action: BulkBeneficiaryFileReducer) => {
    switch (action.type) {
        case bulkBeneficiaryFileType.BULK_BENEFICIARY_FILE_DOWNLOAD: {
            return {
                loading: true,
            };
        }
        case bulkBeneficiaryFileType.BULK_BENEFICIARY_FILE_DOWNLOAD_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null
            };
        }
        case bulkBeneficiaryFileType.BULK_BENEFICIARY_FILE_DOWNLOAD_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                data: {}
            };
        }
        case bulkBeneficiaryFileType.RESET_BULK_BENEFICIARY_FILE_DOWNLOAD: {
            return {
                data: {},
                loading: false,
                error: null
            };
        }
        default:
            return { ...state };
    }
};

const BulkBeneficiaryFileDetailReducer = (state: BulkBeneficiaryFileReducerStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE, action: BulkBeneficiaryFileReducer) => {
    switch (action.type) {
        case bulkBeneficiaryFileType.FETCH_BULK_BENEFICIARY_FILE_DETAIL: {
            return {
                loading: true,
            };
        }
        case bulkBeneficiaryFileType.FETCH_BULK_BENEFICIARY_FILE_DETAIL_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null
            };
        }
        case bulkBeneficiaryFileType.FETCH_BULK_BENEFICIARY_FILE_DETAIL_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                data: {}
            };
        }
        case bulkBeneficiaryFileType.RESET_FETCH_BULK_BENEFICIARY_FILE_DETAIL: {
            return {
                data: {},
                loading: false,
                error: null
            };
        }
        default:
            return { ...state };
    }
};

const BulkBeneficiaryFileVersionReducer = (state: BulkBeneficiaryFileReducerStateWithListObject = OBJECT_WITH_LIST_RESPONSE_INIT_STATE, action: BulkBeneficiaryFileReducer) => {
    switch (action.type) {
        case bulkBeneficiaryFileType.BULK_BENEFICIARY_FILE_VERSION: {
            return {
                loading: true,
            };
        }
        case bulkBeneficiaryFileType.BULK_BENEFICIARY_FILE_VERSION_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null
            };
        }
        case bulkBeneficiaryFileType.BULK_BENEFICIARY_FILE_VERSION_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                data: {
                    metadata: {
                        totalCount: 0,
                        currentPageRecords: 0,
                        totalPages: 0,
                        links: {
                            self: null,
                            first: null,
                            previous: null,
                            next: null,
                            last: null
                        }
                    },
                    records: []
                }
            };
        }
        case bulkBeneficiaryFileType.RESET_BULK_BENEFICIARY_FILE_VERSION: {
            return {
                data: {
                    metadata: {
                        totalCount: 0,
                        currentPageRecords: 0,
                        totalPages: 0,
                        links: {
                            self: null,
                            first: null,
                            previous: null,
                            next: null,
                            last: null
                        }
                    },
                    records: []
                },
                loading: false,
                error: null
            };
        }
        default:
            return { ...state };
    }
};

const PublishBulkBeneficiaryFileReducer = (state: BulkBeneficiaryFileReducerStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE, action: BulkBeneficiaryFileReducer) => {
    switch (action.type) {
        case bulkBeneficiaryFileType.PUBLISH_BULK_BENEFICIARY_FILE: {
            return {
                loading: true,
            };
        }
        case bulkBeneficiaryFileType.PUBLISH_BULK_BENEFICIARY_FILE_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null
            };
        }
        case bulkBeneficiaryFileType.PUBLISH_BULK_BENEFICIARY_FILE_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                data: {}
            };
        }
        case bulkBeneficiaryFileType.RESET_PUBLISH_BULK_BENEFICIARY_FILE: {
            return {
                data: {},
                loading: false,
                error: null
            };
        }
        default:
            return { ...state };
    }
};

const ApproveBulkBeneficiaryFileReducer = (state: BulkBeneficiaryFileReducerStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE, action: BulkBeneficiaryFileReducer) => {
    switch (action.type) {
        case bulkBeneficiaryFileType.APPROVE_BULK_BENEFICIARY_FILE: {
            return {
                loading: true,
            };
        }
        case bulkBeneficiaryFileType.APPROVE_BULK_BENEFICIARY_FILE_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null
            };
        }
        case bulkBeneficiaryFileType.APPROVE_BULK_BENEFICIARY_FILE_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                data: {}
            };
        }
        case bulkBeneficiaryFileType.RESET_APPROVE_BULK_BENEFICIARY_FILE: {
            return {
                data: {},
                loading: false,
                error: null
            };
        }
        default:
            return { ...state };
    }
};

const RejectBulkBeneficiaryFileReducer = (state: BulkBeneficiaryFileReducerStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE, action: BulkBeneficiaryFileReducer) => {
    switch (action.type) {
        case bulkBeneficiaryFileType.REJECT_BULK_BENEFICIARY_FILE: {
            return {
                loading: true,
            };
        }
        case bulkBeneficiaryFileType.REJECT_BULK_BENEFICIARY_FILE_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null
            };
        }
        case bulkBeneficiaryFileType.REJECT_BULK_BENEFICIARY_FILE_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                data: {}
            };
        }
        case bulkBeneficiaryFileType.RESET_REJECT_BULK_BENEFICIARY_FILE: {
            return {
                data: {},
                loading: false,
                error: null
            };
        }
        default:
            return { ...state };
    }
};

const ListBulkFileSpecificBeneficiaryReducer = (state: BulkBeneficiaryFileReducerStateWithListObject = OBJECT_WITH_LIST_RESPONSE_INIT_STATE, action: BulkBeneficiaryFileReducer) => {
    switch (action.type) {
        case bulkBeneficiaryFileType.FETCH_BULK_FILE_SPECIFIC_BENEFICIARY: {
            return {
                ...state,
                loading: true,
            };
        }
        case bulkBeneficiaryFileType.FETCH_BULK_FILE_SPECIFIC_BENEFICIARY_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null
            };
        }
        case bulkBeneficiaryFileType.FETCH_BULK_FILE_SPECIFIC_BENEFICIARY_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                data: {
                    metadata: {
                        totalCount: 0,
                        currentPageRecords: 0,
                        totalPages: 0,
                        links: {
                            self: null,
                            first: null,
                            previous: null,
                            next: null,
                            last: null
                        }
                    },
                    records: []
                }
            };
        }
        case bulkBeneficiaryFileType.RESET_FETCH_BULK_FILE_SPECIFIC_BENEFICIARY: {
            return {
                ...state,
                data: {
                    metadata: {
                        totalCount: 0,
                        currentPageRecords: 0,
                        totalPages: 0,
                        links: {
                            self: null,
                            first: null,
                            previous: null,
                            next: null,
                            last: null
                        }
                    },
                    records: []
                },
                loading: false,
                error: null
            };
        }
        default:
            return { ...state };
    }
};


const DeleteBulkBeneficiaryFileReducer = (state: BulkBeneficiaryFileReducerStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE, action: BulkBeneficiaryFileReducer) => {
    switch (action.type) {
        case bulkBeneficiaryFileType.DELETE_BULK_BENEFICIARY_FILE: {
            return {
                loading: true,
            };
        }
        case bulkBeneficiaryFileType.DELETE_BULK_BENEFICIARY_FILE_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null
            };
        }
        case bulkBeneficiaryFileType.DELETE_BULK_BENEFICIARY_FILE_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                data: {}
            };
        }
        case bulkBeneficiaryFileType.RESET_DELETE_BULK_BENEFICIARY_FILE: {
            return {
                data: {},
                loading: false,
                error: null
            };
        }
        default:
            return { ...state };
    }
};


export {
    UploadBulkBeneficiaryFileReducer,
    ListBulkBeneficiaryFileReducer,
    DownloadBulkBeneficiaryFileReducer,
    BulkBeneficiaryFileDetailReducer,
    BulkBeneficiaryFileVersionReducer,
    PublishBulkBeneficiaryFileReducer,
    ApproveBulkBeneficiaryFileReducer,
    RejectBulkBeneficiaryFileReducer,
    ListBulkFileSpecificBeneficiaryReducer,
    DeleteBulkBeneficiaryFileReducer
}